import { useSyncExternalStore } from 'react';

/** 版面斷點（與 CSS 一致）：手機 < 640、平板 640–1023、桌面 ≥ 1024 */
export const BREAKPOINTS = {
  phone: '(max-width: 639px)',
  tablet: '(min-width: 640px) and (max-width: 1023px)',
} as const;

/** 媒體查詢的即時結果。只在需要「元件放在不同位置」時使用；單純的樣式差異交給 CSS。 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
